import Intl from 'intl';
Intl.__addLocaleData(window.__intlLocaleData);
